import { type StreamMessage } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import type { MessageResearch, ResearchPlan, ResearchStep } from './MessageResearch';
import { useStoreByMessageId } from './useStoreByMessageId';

export const useChatMessageResearchByRoundId = ({
	messageId,
	roundId,
}: {
	messageId: string;
	roundId: number;
}): {
	artificiallyProgressingSteps: ResearchStep[];
	isAllStepsCompleted: boolean;
	researchCompleted: boolean | undefined;
	errored: boolean | undefined;
	resetHasReceivedAnswerPart: (args_0: { messageId: string }) => void;
	addImplicitResearchPlan: (args_0: {
		messageId: string;
		content: string;
		roundId: number;
	}) => void;
	processStreamResearch: (args_0: {
		messageId: string;
		streamMessage: StreamMessage;
		isDeepResearch?: boolean;
	}) => void;
	updateResearchMessageId: (args_0: { messageId: string; newMessageId: string }) => void;
	incrementProgressArtificially: (args_0: { messageId: string }) => void;
	markIncompleteResearchesErrored: (args_0: { messageId: string }) => void;
	completeAllSteps: (args_0: { messageId: string }) => void;
	getMessageResearchById: (args_0: { messageId: string }) => MessageResearch | undefined;
	clearMessageResearch: (args_0: { messageId: string }) => void;
	steps?:
		| {
				[stepId: string]: ResearchStep;
		  }
		| undefined;
	researchPlans?:
		| {
				[roundId: number]: ResearchPlan;
		  }
		| undefined;
	hasReceivedAnswerPart?: boolean;
	currentProgress?: number;
	isDeepResearch?: boolean;
	hasThinkDeeperTriggered?: boolean;
} => {
	const [state, actions] = useStoreByMessageId(messageId);

	const steps = Object.values(state?.steps ?? {}).filter((step) => step.roundId === roundId);
	const isAllStepsCompleted = steps.every((step) => !!step.completed);

	return {
		...state,
		...actions,
		artificiallyProgressingSteps: steps,
		isAllStepsCompleted,
		researchCompleted: state?.researchCompleted,
		errored: state?.errored,
	};
};
